






























































































import { Component, Vue } from "vue-property-decorator";
import { Button, Overlay } from "vant";
import { uploadBase64 } from "@/api/api.config";

Vue.use(Button);
Vue.use(Overlay);

@Component
export default class Index extends Vue {
  signatureImg: any = "";
  isShowSignature = false;
  ctx: any;
  mousePressed = false;
  canvasDom: any;
  lastX = 0;
  lastY = 0;
  width: any = window.innerWidth - 40;
  get owner() {
    return localStorage.getItem("OWNER") || "";
  }

  get companyName() {
    return localStorage.getItem("companyName") || "";
  }

  get type() {
    return this.$route.query.type;
  }

  get date() {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    return `${year}-${month}-${day}`;
  }

  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      vm.signatureImg = "";
    });
  }
  beforeRouteLeave(to: any, from: any, next: any) {
    to.meta.keepAlive = true;
    next(0);
  }

  signature() {
    this.signatureImg = "";
    this.mousePressed = false;
    this.isShowSignature = true;
    this.$nextTick(() => {
      this.canvasDom = this.$refs.canvas;
      this.ctx = (document as any).getElementById("canvas").getContext("2d");
    });
  }

  touchstart(e: any) {
    if (e.targetTouches.length == 1) {
      e.preventDefault();
      var touch = e.targetTouches[0];
      this.mousePressed = true;
      this.draw(
        touch.pageX - this.canvasDom.offsetLeft,
        touch.pageY - this.canvasDom.offsetTop,
        false
      );
    }
  }

  touchmove(e: any) {
    if (e.targetTouches.length == 1) {
      e.preventDefault();
      var touch = e.targetTouches[0];
      if (this.mousePressed) {
        this.draw(
          touch.pageX - this.canvasDom.offsetLeft,
          touch.pageY - this.canvasDom.offsetTop,
          true
        );
      }
    }
  }

  draw(x: any, y: any, isDown: any) {
    if (isDown) {
      this.ctx.beginPath();
      this.ctx.strokeStyle = "#000";
      this.ctx.lineWidth = 3;
      this.ctx.lineJoin = "round";
      this.ctx.lineMax = 10;
      this.ctx.lineMin = 3;
      this.ctx.linePressure = 1.2;
      this.ctx.smoothness = 30;
      this.ctx.moveTo(this.lastX, this.lastY);
      this.ctx.lineTo(x, y);
      this.ctx.closePath();
      this.ctx.stroke();
    }
    this.lastX = x;
    this.lastY = y;
  }

  touchend(e: any) {
    if (e.targetTouches.length == 1) {
      e.preventDefault();
      this.mousePressed = false;
    }
  }

  cancelDraw() {
    this.ctx.setTransform(1, 0, 0, 1, 0, 0);
    this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
  }

  confirmDraw() {
    const c = document.getElementById("canvas");
    if (this.isCanvasBlank(c)) {
      this.toast("请完成签名");
      return;
    } else {
      var image = this.canvasDom.toDataURL("image/png");
      this.uploadBase64(image);
    }
  }

  uploadBase64(file: any) {
    uploadBase64({
      file: file,
    })
      .then(({ data }) => {
        this.signatureImg = data;
        localStorage.setItem("signatureImg", this.signatureImg);
        this.isShowSignature = false;
        this.cancelDraw();
      })
      .catch(() => {
        this.signatureImg = "";
        this.isShowSignature = false;
      });
  }

  isCanvasBlank(canvas: any) {
    var c = document.createElement("canvas");
    c.width = canvas.width;
    c.height = canvas.height;
    return canvas.toDataURL() == c.toDataURL();
  }

  submit() {
    if (this.type == "2") {
      this.$router.replace({
        path: "index",
        query: { id: this.$route.query.id },
      });
    } else {
      if (!this.signatureImg) {
        return;
      }
      this.$router.push({
        path: "/index",
        query: {
          id: this.$route.query.id,
          product: this.$route.query.product,
          signatureImg: this.signatureImg,
        },
      });
    }
  }

  mounted() {
    window.addEventListener("resize", resizeCanvas, false);
    let that = this;
    function resizeCanvas() {
      that.width = window.innerWidth - 20;
    }
  }
}
